import { Pipe, PipeTransform, inject } from '@angular/core';

import { ProjectFacade } from '@mitsubishi/project/data-access';
import { ApmCurrencyPipe } from '@mitsubishi/shared/ui';

@Pipe({
  name: 'apmProjectCurrency',
  standalone: true,
})
export class ApmProjectCurrencyPipe implements PipeTransform {
  #projectFacade = inject(ProjectFacade);

  readonly currencySymbol = this.#projectFacade.currentSelectionOrStudyCurrencySymbol;

  constructor(private currencyPipe: ApmCurrencyPipe) {}

  transform(
    value: number | undefined | null,
    currencyCode?: string | null | undefined,
    onTransform?: (value: string) => void
  ) {
    return this.currencyPipe.transform(value, currencyCode ?? this.currencySymbol(), onTransform) ?? '';
  }
}
